<template>
    <v-row no-gutters>
        <v-col>
            <v-card class="mx-4 my-2" :style="outlined ? 'border: 1px solid blue;' : ''">
                <v-card-title>
                    <v-row no-gutters>
                        <v-col cols="auto">
                            <v-icon class="mr-3">{{ icon ? icon : 'mdi-question' }}</v-icon>
                        </v-col>
                        <v-col cols="auto">
                            <h3 class="mb-0">{{ title ? title : 'Feature title' }}</h3>
                        </v-col>
                        <v-col v-if="subtitle" cols="auto" class="mx-2">
                            <h6 style="opacity: 0.7; font-size: 16px;">{{ subtitle }}</h6>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="auto" :class="activeClass">
                            <v-row no-gutters>
                                {{ activeText }}
                                <v-switch v-if="activeToggle != undefined" :value="active" class="ma-0 ml-2" dense
                                    :disabled="disabled" hide-details @change="activeToggle()">
                                </v-switch>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-title>
                <v-card-text>
                    <slot name="description">
                        <div v-html="description ? description : 'Feature description'" />
                    </slot>
                    <slot name="more" />
                </v-card-text>
            </v-card>
        </v-col>
    </v-row>
</template>


<script>
export default {
    name: 'FeatureCard',
    props: {
        icon: String,
        title: String,
        subtitle: String,
        description: String,
        disabled: Boolean,
        active: Boolean,
        outlined: Boolean,
        activeToggle: Function,
    },
    components: {},

    data() {
        return {};
    },

    methods: {},

    computed: {
        activeClass() {
            if (this.active == undefined) {
                return '';
            }
            if (this.active) {
                return 'success--text';
            }
            else {
                return 'error--text';
            }
        },

        activeText() {
            if (this.active == undefined) {
                return '';
            }
            if (this.active) {
                return 'Active';
            }
            else {
                return 'Disabled';
            }
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>